// STUB — FTMS Treadmill Data characteristic (0x2ACD). Spec §4.7.
//
// Phase 2: implement following the inverted-bit-0 + length-guarded pattern
// from indoorBike.ts. Treadmill flags are 16-bit; field schedule starts with
// Instantaneous Speed (uint16, ×0.01 km/h) when bit 0 is CLEAR, then Average
// Speed, Total Distance (uint24), Inclination + Ramp Angle, Elevation Gain,
// Instantaneous Pace, Average Pace, Energy, Heart Rate, MET, Elapsed Time,
// Remaining Time, Force on Belt + Power Output.

import type { TreadmillMetrics } from "../types";

export function parseTreadmillData(_view: DataView): TreadmillMetrics {
  return {
    type: "treadmill",
    power_watts: null,
    heart_rate_bpm: null,
    elapsed_time_s: null,
    remaining_time_s: null,
    speed_kmh: null,
    incline_pct: null,
    total_distance_m: null,
  };
}
